// extracted by mini-css-extract-plugin
export default {"cartBadge":"_3U0QwCk1wX8aykesiabUJ5"};